<script>
  import { filtersConfigStore } from "@stores/filtersConfigStores.js";
  import { pmfilters } from "lib/stores.js";
  import { getApplicableFilters } from "../../../../lib/util/getApplicableFilters";
  import { useNavigate } from "svelte-navigator";
  import { ROUTES } from "@utils/routes.js";
  // ui-elements
  import Toggle from "lib/components/Toggle.svelte";
  import UIViewer from "./components/UIViewer.svelte";

  import Filter from "./components/filter/Filter.svelte";
  import FilterToast from "./components/FilterToast.svelte";

  // sidenav

  import { Accordion, SectionWrapper, Button } from "paxray-components-svelte";
  import AppSelection from "./components/appSelection.svelte";
  import AppInformation from "./components/appInformation.svelte";
  import Header from "lib/components/Header.svelte";
  import { Slider } from "carbon-components-svelte";

  import { fetchWithSession } from "lib/util/fetchWithSession.js";
  import {
    FULLSCREEN_ICON,
    FULLSCREEN_OFF_ICON,
    ARROW_LEFT_ICON,
    UPLOAD_ICON,
    SQUARE_LANDSCAPE_ICON,
  } from "@utils/icons.js";

  const navigate = useNavigate();
  export let analysisid;
  const { setCurrentView } = filtersConfigStore;

  let currentApp = "";
  let windowPartitionsLoading = false;

  let drawClicks = true;
  let drawScreenshot = true;
  let drawUIElements = false;
  let applicationlist = [];
  let windowlist = [];
  let fileUploader;
  let triggerUpdate = false;
  let fullscreen = false;
  let disabledlevels = [0, 2];
  let selectedLevel = 1;
  let scale = 50;
  let loading = true;
  let loadingApp = true;
  let view = "Mask Analysis";
  let showToast = false;
  let UIViewerElement;

  $: setCurrentView(view);

  $: if ($pmfilters[analysisid] && $filtersConfigStore.storeLoaded) {
    getWindowPartitions();
  }

  $: {
    if (currentApp !== "") {
      localStorage.getItem("appScales") &&
        JSON.parse(localStorage.getItem("appScales")).forEach((item) => {
          if (item.currentApp === currentApp) {
            scale = item.scale;
          }
        });
    }
  }

  function getWindowPartitions() {
    loading = true;
    loadingApp = true;
    windowPartitionsLoading = true;
    const applicableFilters = getApplicableFilters($pmfilters[analysisid]);
    const filterString = JSON.stringify(applicableFilters);
    fetchWithSession(
      `/api/analysis/getWindowPartitions?analysisid=${analysisid}&filter=${filterString}`,
    )
      .then((res) => res.json())
      .then((data) => {
        windowlist = data;
        windowPartitionsLoading = false;
        loading = false;
      });
    fetchWithSession(
      `/api/analysis/AppOverviewKPIs?analysisid=${analysisid}&filter=${filterString}`,
    )
      .then((res) => res.json())
      .then((data) => {
        applicationlist = data;
        windowPartitionsLoading = false;
        loadingApp = false;
      });
  }

  async function uploadScreenshot(dataurl) {
    const res = await fetchWithSession(`/api/analysis/uploadScreenshot`, {
      method: "POST",
      body: JSON.stringify({
        analysisid: analysisid,
        partitionlabel: currentApp,
        screenshot: dataurl,
      }),
    });
    if (res.ok) {
      triggerUpdate = true;
    } else {
      throw new Error(text);
    }
  }

  function handleFileUpload(e) {
    var reader = new FileReader();
    reader.onload = function (event) {
      uploadScreenshot(event.target.result);
    };

    reader.readAsDataURL(e.target.files[0]);
  }

  function saveScale() {
    let scales = JSON.parse(localStorage.getItem("appScales")) || [];
    const data = { scale, currentApp };
    scales.push(data);
    localStorage.setItem("appScales", JSON.stringify(scales));
  }

  $$restProps;
</script>

<FilterToast bind:showToast />

<Header section="Usage Analysis" breadcrumb="Mask Analysis">
  <Button
    text="To Dashboard"
    on:click={() => {
      navigate(`${ROUTES.analysis.dashboard}?analysisid=${analysisid}`);
    }}
    iconLeft={true}
    icon={ARROW_LEFT_ICON}
    kind="secondary"
  />
  <Filter />
</Header>

<SectionWrapper {fullscreen} fitScreen={true}>
  <div slot="main" class="main_wapper">
    <div class="canvas">
      <div class="ui_viewer_wrapper">
        <UIViewer
          bind:this={UIViewerElement}
          partitionlabel={currentApp}
          {analysisid}
          {drawClicks}
          {drawUIElements}
          {drawScreenshot}
          bind:triggerUpdate
          {scale}
        />
      </div>
    </div>
    <div class="menu_overlay bottom">
      <div class="slider_wrapper">
        <Slider bind:value={scale} max={150} fullWidth={true} />
      </div>
      <div class="buttons_wrapper">
        <Button text="Save" on:click={saveScale} kind="secondary" />
        <Button
          kind="secondary"
          icon={SQUARE_LANDSCAPE_ICON}
          on:click={() => {
            if (UIViewerElement) UIViewerElement.downloadSVG();
          }}
        />
        {#if fullscreen === false}
          <Button
            kind="secondary"
            icon={FULLSCREEN_ICON}
            on:click={() => {
              fullscreen = true;
            }}
          />
        {:else}
          <Button
            kind="secondary"
            icon={FULLSCREEN_OFF_ICON}
            on:click={() => {
              fullscreen = false;
            }}
          />
        {/if}
      </div>
    </div>
  </div>

  <div class="menu" slot="menu">
    <Accordion heading="App Selection" open={true}>
      <AppSelection
        appData={selectedLevel ? windowlist : applicationlist}
        bind:currentApp
        bind:selectedLevel
        windowSelectionEnabled={false}
        enableDeselection={false}
        loading={selectedLevel ? loading : loadingApp}
      />
    </Accordion>
    <Accordion heading="App Information" open={true}>
      <AppInformation
        appData={selectedLevel ? windowlist : applicationlist}
        {currentApp}
        loading={selectedLevel ? loading : loadingApp}
      />
    </Accordion>

    <Accordion heading="Settings" open={true}>
      <div class="toggle_wrapper">
        <Toggle text="UI-Elements" bind:active={drawUIElements} />
        <Toggle text="Clusters" bind:active={drawClicks} />
        <Toggle text="Screenshot" bind:active={drawScreenshot} />
        <div class="upload_wrapper">
          <Button
            on:click={() => {
              fileUploader.click();
            }}
            kind="secondary"
            iconLeft={true}
            icon={UPLOAD_ICON}
            text="Upload Screenshot"
            disable={true}
          />
          <input
            type="file"
            id="file"
            style="display:none"
            bind:this={fileUploader}
            on:change={handleFileUpload}
          />
        </div>
      </div>
    </Accordion>
  </div>
</SectionWrapper>

<style>
  .upload_wrapper {
    padding-top: 1rem;
    margin-top: 1rem;
    border-top: 1px solid #d9d9d9;
  }

  .toggle_wrapper {
    display: flex;
    flex-direction: column;
  }

  .main_wapper {
    position: relative;
    height: 100%;
    width: 100%;
    min-width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .menu_overlay {
    position: absolute;
    width: 100%;
    z-index: 1; /* Stellt sicher, dass das Overlay über dem Canvas liegt */
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .bottom {
    bottom: 0;
  }

  .canvas {
    height: calc(100% - 110px);
    width: 100%;
    z-index: 0; /* Platziert das Canvas hinter den Overlays */
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .slider_wrapper {
    flex: 1 1 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 10rem 0.5rem 1rem;
  }

  .buttons_wrapper {
    display: flex;
    gap: 0.5rem;
    user-select: none;
    flex: 0 1 auto;
  }

  .menu {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .ui_viewer_wrapper {
    height: 100%;
    width: 100%;
  }
</style>
